import {
  handleActions,
} from 'redux-actions';
import { SortDirection } from '@piwikpro/json-api';
import {
  actions,
} from '@piwikpro/user-groups-crate';
import { UserGroup } from '../model';

const {
  userGroupsFetchInitialized,
  userGroupsFetchSucceeded,
  userGroupsFetchFailed,
  configureUserGroupsFetch,
} = actions;

const isUnderUserGroupsRoute = new RegExp('/user-groups(.*)');

export interface UserGroupListState {
  isLoading: boolean
  failed: boolean
  userGroups: UserGroup[]
  total: number
  filters: {
    sort: {
      by: string
      direction: SortDirection
    }
    search: string
  }
}

const initialState: UserGroupListState = {
  isLoading: false,
  failed: false,
  userGroups: [],
  total: 0,
  filters: {
    sort: {
      by: 'name',
      direction: SortDirection.DESC,
    },
    search: '',
  },
};

const reducer = handleActions<UserGroupListState, any>({
  [userGroupsFetchInitialized.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: true,
    userGroups: !payload.offset ? initialState.userGroups : [...state.userGroups],
    total: !payload.offset ? initialState.total : state.total,
    filters: {
      ...state.filters,
      ...payload,
    },
  }),
  [userGroupsFetchSucceeded.toString()]: (state, { payload }) => {
    const userGroups = [
      ...state.userGroups,
      ...payload.data,
    ];

    return {
      ...state,
      userGroups: Array.from(new Set(userGroups.map(userGroup => userGroup.id)))
        .map(id => userGroups.find(userGroup => userGroup.id === id)),
      total: state.total > 0 ? state.total : payload.meta.total,
      isLoading: false,
      failed: false,
    };
  },
  [userGroupsFetchFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
    total: 0,
  }),
  [configureUserGroupsFetch.toString()]: (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
    },
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderUserGroupsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
